import { Routes } from '@angular/router';
import { MyAccountContainerComponent } from './pages/my-account-container/my-account-container.component';

export const routes: Routes = [
  {
    path: '',
    component: MyAccountContainerComponent,
    children: [
      {
        path: 'personal',
        loadChildren: () =>
          import(
            './modules/my-account-personal/my-account-personal.routing'
          ).then((m) => m.routes)
      },
      {
        path: 'general',
        loadChildren: () =>
          import(
            './modules/my-account-general/my-account-general.routing'
          ).then((m) => m.routes)
      },
      { path: '', pathMatch: 'full', redirectTo: 'personal' }
    ]
  }
];
